export default __webpack_public_path__ + "static/media/Consecrated Libram.f4f9f216.jpg";